import { ContractorBranchResponse } from "@/models/api/administration/contractors/ContractorBranchResponse";
import CancellableHelper from "@/requests/CancellableHelper";

// Routes
export const URL_GET_BRANCH_CONTRACTORS = "/ContractorAdministration/${ContractorId}/GetBranchContractors";
export const URL_POST_ADD_CONTRACTORS_TO_THE_BRANCH = "/ContractorAdministration/${ParentId}/AddContractorsToTheBranch";
export const URL_POST_REMOVE_CONTRACTOR_FROM_THE_BRANCH =
  "/ContractorAdministration/${ContractorId}/RemoveContractorFromTheBranch";

// Requests
const _getBranchContractors = new CancellableHelper<ContractorBranchResponse>(
  URL_GET_BRANCH_CONTRACTORS,
  ContractorBranchResponse
);
export const getBranchContractors = async (contractorId: string): Promise<ContractorBranchResponse> => {
  return _getBranchContractors.get({ ContractorId: contractorId });
};

const _addContractorToTheBranch = new CancellableHelper<null>(URL_POST_ADD_CONTRACTORS_TO_THE_BRANCH, null, true);
export const addContractorToTheBranch = async (parentId: string, children: Array<string>): Promise<null> => {
  return _addContractorToTheBranch.post(
    {
      ParentId: parentId,
    },
    children
  );
};

const _removeContractorFromTheBranch = new CancellableHelper<null>(
  URL_POST_REMOVE_CONTRACTOR_FROM_THE_BRANCH,
  null,
  true
);
export const removeContractorFromTheBranch = async (contractorId: string): Promise<null> => {
  return _removeContractorFromTheBranch.post({ ContractorId: contractorId });
};
